// Footer.jsx
import React from 'react';
import './Footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content footer__content--compact">
        <div className="footer__brand">
          <h3>ilhomPC</h3>
        </div>
        <ul className="footer__contacts">
          <li>📞 Ильхом: <a href="tel:+998916424053">+998 91 642 40 53</a></li>
          <li>📞 Талят: <a href="tel:+998998473854">+998 99 847 38 54</a></li>
          <li>✈️ Telegram: <a href="https://t.me/ilhompc" target="_blank" rel="noreferrer">@ilhompc</a></li>
          <li>📍 Ташкент, Узбекистан</li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
